import { Shield } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

/** "Só administradores": a small switch for the form header, not a block of its own. */
export function AdminOnlyToggle({ value, onChange }: { value: boolean; onChange: (next: boolean) => void }) {
  const { t } = useLanguage();
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      onClick={() => onChange(!value)}
      title={t('form.adminOnly.description')}
      className={`inline-flex items-center gap-2 h-8 pl-2.5 pr-1.5 rounded-full border text-xs font-medium whitespace-nowrap transition-colors ${
        value
          ? 'border-brand-ink bg-brand-ink text-white'
          : 'border-gray-200 bg-white text-gray-600 hover:border-gray-400'
      }`}
    >
      <Shield className="w-3.5 h-3.5" />
      {t('form.adminOnly.short')}
      <span className={`relative inline-flex h-4 w-7 items-center rounded-full transition-colors ${value ? 'bg-brand-lime' : 'bg-gray-300'}`}>
        <span className={`inline-block h-3 w-3 rounded-full bg-white shadow-sm transition-transform ${value ? 'translate-x-[14px]' : 'translate-x-[2px]'}`} />
      </span>
    </button>
  );
}
